//dependencies
import $ from "jquery";
import Cookies from "js-cookie";

export default function () {

    function initScript() {
        console.log("Ini cookie alert")
        var acceptCookie = Cookies.get('acceptsCookies');
        console.log(acceptCookie);
        if (acceptCookie != 'true') {
            $('#alert').show();
        }
        $('#cookie-disclaimer-close').click(function () {
            console.log("Clicked close")
            if (acceptCookie != 'true') {
                Cookies.set('acceptsCookies', 'true', { expires: 7 });
                $('.cookies-disclaimer').slideUp();
                return false;
            }
        });
    }
    initScript();
}


// WEBPACK FOOTER //
// ./src/ui/js/apps/cookieAlert.js